"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var components_1 = require("@lsg/components");

var helper_1 = require("./helper");

exports.LsgPicture = function (_a) {
  var fluidData = _a.fluidData,
      asBackgroundImage = _a.asBackgroundImage,
      asInline = _a.asInline,
      backgroundFocalPoint = _a.backgroundFocalPoint,
      imgWidth = _a.imgWidth,
      imgHeight = _a.imgHeight,
      maxWidth = _a.maxWidth,
      style = _a.style,
      className = _a.className,
      id = _a.id,
      children = _a.children,
      alt = _a.alt;
  return react_1["default"].createElement(components_1.Picture, {
    src: helper_1.createLsgSrcsetFromFluidImage(fluidData) || '',
    asBackgroundImage: asBackgroundImage,
    asInline: asInline,
    backgroundFocalPoint: backgroundFocalPoint,
    imgWidth: imgWidth,
    imgHeight: imgHeight,
    maxWidth: maxWidth,
    style: style,
    className: className,
    id: id,
    alt: alt
  }, children);
};